/**
 * version.ts (M91) — the deploy marker, SHOWN on the title footer so anyone
 * (especially the owner, live-testing on phones) can see at a glance which
 * build a device is actually running — a stale service-worker shell was
 * indistinguishable from a real bug before this.
 *
 * KEEP IN SYNC with public/sw.js `VERSION` when deploying (both are bumped
 * per milestone; the deploy checklist in CLAUDE.md says so too).
 */
export const BUILD_TAG = 'dr-v148';
